import React, { FC } from 'react';

type Props = {
  title: string;
};

export const FooterGroup: FC<Props> = ({ children, title }) => {
  return (
    <div className="footer__group">
      <span className="footer__group__title">{title}</span>
      <ul className="footer__group__list">{children}</ul>
    </div>
  );
};
